export const Sports = [
    {"sportId": 1, "createdBy": 0, "name": "Hockey", "shortName": "HOC", "status": 1},
    {"sportId": 2, "createdBy": 0, "name": "Basketball", "shortName": "BAS", "status": 1},
    {"sportId": 3, "createdBy": 0, "name": "Soccer", "shortName": "SOC", "status": 1},
    {"sportId": 4, "createdBy": 0, "name": "Football", "shortName": "FOT", "status": 1},
    {"sportId": 5, "createdBy": 0, "name": "Tennis", "shortName": "TEN", "status": 1},
    {"sportId": 6, "createdBy": 0, "name": "Presidential Election", "shortName": "PE", "status": 1},
    {"sportId": 7, "createdBy": 0, "name": "Moto", "shortName": "MOTO", "status": 1},
    {"sportId": 9, "createdBy": 0, "name": "BaseBall", "shortName": "BB", "status": 1},
    {"sportId": 11, "createdBy": 0, "name": "Financial", "shortName": "FIN", "status": 1},
    {"sportId": 12, "createdBy": 0, "name": "Golf", "shortName": "Golf", "status": 1}]

export const SportsNameMap = Object.fromEntries(
    Sports.map(({ sportId, name }) => [sportId, name])
);

export const Leagues = [
    {leagueId: 1, shortName: "NHL"},
    {leagueId: 2, shortName: "NBA"},
    {leagueId: 3, shortName: "FIFA"},
    {leagueId: 4, shortName: "MLB"},
    {leagueId: 5, shortName: "NFL"},
    {leagueId: 6, shortName: "FIN"},
    {leagueId: 7, shortName: "SOCCER"},
    {leagueId: 12, shortName: "GOLF"}
];

export const Seasons = [
    {
        abvr: "MLS",
        sportId: 3,
        seasonId: "127179",
        name: "Major League Soccer 2025",
        isActive: true
    },
    {
        abvr: "LMX",
        sportId: 3,
        seasonId: "130979",
        name: "Liga MX, Apertura 2025",
        isActive: true

    },
    {
        abvr: "EPL",
        sportId: 3,
        seasonId: "130281",
        name: "Premier League 2025",
        isActive: true
    },
    {
        abvr: "L1",
        sportId: 3,
        seasonId: "131609",
        name: "Ligue 1 2025",
        isActive: true
    }
];

export const SeasonsAbvrMap = Object.fromEntries(
    Seasons.map(({ seasonId, abvr }) => [seasonId, abvr])
);

export const NHLTeams = {
    '42376e1c-6da8-461e-9443-cfcf0a9fcc4d': { key: 'VGK', baseColor: "#B4975A", secondaryColor: "#333F42" }, // Vegas Golden Knights
    '44151f7a-0f24-11e2-8525-18a905767e44': { key: 'LA', baseColor: "#111111", secondaryColor: "#A2AAAD" }, // Los Angeles Kings
    '44153da1-0f24-11e2-8525-18a905767e44': { key: 'ARI', baseColor: "#8C2633", secondaryColor: "#E2D6B5" }, // Arizona Coyotes
    '44155909-0f24-11e2-8525-18a905767e44': { key: 'SJ', baseColor: "#006D75", secondaryColor: "#EA7200" }, // San Jose Sharks
    '4415ea6c-0f24-11e2-8525-18a905767e44': { key: 'EDM', baseColor: "#041E42", secondaryColor: "#FF4C00" }, // Edmonton Oilers
    '441862de-0f24-11e2-8525-18a905767e44': { key: 'ANA', baseColor: "#F47A38", secondaryColor: "#B09862" }, // Anaheim Ducks
    '44157522-0f24-11e2-8525-18a905767e44': { key: 'DAL', baseColor: "#006847", secondaryColor: "#8F8F8C" }, // Dallas Stars
    '4415ce44-0f24-11e2-8525-18a905767e44': { key: 'COL', baseColor: "#6F263D", secondaryColor: "#236192" }, // Colorado Avalanche
    '4416091c-0f24-11e2-8525-18a905767e44': { key: 'MIN', baseColor: "#154734", secondaryColor: "#EAAA00" }, // Minnesota Wild
    '4416272f-0f24-11e2-8525-18a905767e44': { key: 'CHI', baseColor: "#CF0A2C", secondaryColor: "#FF671B" }, // Chicago Blackhawks
    '441643b7-0f24-11e2-8525-18a905767e44': { key: 'NSH', baseColor: "#FFB81C", secondaryColor: "#041E42" }, // Nashville Predators
    '441660ea-0f24-11e2-8525-18a905767e44': { key: 'STL', baseColor: "#002F87", secondaryColor: "#FCB514" }, // St. Louis Blues
    '44180e55-0f24-11e2-8525-18a905767e44': { key: 'WPG', baseColor: "#041E42", secondaryColor: "#004C97" }, // Winnipeg Jets
    '4416d559-0f24-11e2-8525-18a905767e44': { key: 'BUF', baseColor: "#002654", secondaryColor: "#FCB514" }, // Buffalo Sabres
    '4417d3cb-0f24-11e2-8525-18a905767e44': { key: 'TB', baseColor: "#002868", secondaryColor: "#FFFFFF" }, // Tampa Bay Lightning
    '4418464d-0f24-11e2-8525-18a905767e44': { key: 'FLA', baseColor: "#041E42", secondaryColor: "#C8102E" }, // Florida Panthers
    '44167db4-0f24-11e2-8525-18a905767e44': { key: 'CBJ', baseColor: "#041E42", secondaryColor: "#C8102E" }, // Columbus Blue Jackets
    '44174b0c-0f24-11e2-8525-18a905767e44': { key: 'NJ', baseColor: "#CE1126", secondaryColor: "#000000" }, // New Jersey Devils
    '441766b9-0f24-11e2-8525-18a905767e44': { key: 'NYI', baseColor: "#00539B", secondaryColor: "#F47D30" }, // New York Islanders
    '441781b9-0f24-11e2-8525-18a905767e44': { key: 'NYR', baseColor: "#0038A8", secondaryColor: "#CE1126" }, // New York Rangers
    '44179d47-0f24-11e2-8525-18a905767e44': { key: 'PHI', baseColor: "#F74902", secondaryColor: "#000000" }, // Philadelphia Flyers
    '4417b7d7-0f24-11e2-8525-18a905767e44': { key: 'PIT', baseColor: "#000000", secondaryColor: "#CFC493" }, // Pittsburgh Penguins
    '4417eede-0f24-11e2-8525-18a905767e44': { key: 'WSH', baseColor: "#041E42", secondaryColor: "#C8102E" }, // Washington Capitals
    '44182a9d-0f24-11e2-8525-18a905767e44': { key: 'CAR', baseColor: "#CC0000", secondaryColor: "#000000" }, // Carolina Hurricanes
    '1fb48e65-9688-4084-8868-02173525c3e1': { key: 'SEA', baseColor: "#001628", secondaryColor: "#99D9D9" }, // Seattle Kraken
    '715a1dba-4e9f-4158-8346-3473b6e3557f': { key: 'UTA', baseColor: "#6cace4", secondaryColor: "#000000" }, // Hockey Club
    "441713b7-0f24-11e2-8525-18a905767e44": { key: 'MTL', baseColor: "#AF1E2D", secondaryColor: "#192168"}, // Montreal Canadiens
    "4416f5e2-0f24-11e2-8525-18a905767e44": { key: "OTT", baseColor: "#C52032", secondaryColor: "#000000"}, // Ottawa Senators
    "441730a9-0f24-11e2-8525-18a905767e44": { key: "TOR", baseColor: "#003E7E", secondaryColor: "#FFFFFF"}, // Toronto Maple Leafs
    "4416ba1a-0f24-11e2-8525-18a905767e44": { key: "BOS", baseColor: "#FFB81C", secondaryColor: "#000000"}, // Boston Bruins
    "44159241-0f24-11e2-8525-18a905767e44": { key: "CGY", baseColor: "#C8102E", secondaryColor: "#F1BE48"}, // Calgary Flames
    "4415b0a7-0f24-11e2-8525-18a905767e44": { key: "VAN", baseColor: "#00205B", secondaryColor: "#00843D"} // Vancouver Canucks
};
export const NBATeams = {
    '583ec8d4-fb46-11e1-82cb-f4ce4684ea4c': { key: 'WAS', baseColor: "#002B5C", secondaryColor: "#E31837" }, // Washington Wizards
    '583ec97e-fb46-11e1-82cb-f4ce4684ea4c': { key: 'CHA', baseColor: "#1D1160", secondaryColor: "#00788C" }, // Charlotte Hornets
    '583ecb8f-fb46-11e1-82cb-f4ce4684ea4c': { key: 'ATL', baseColor: "#C8102E", secondaryColor: "#FDB927" }, // Atlanta Hawks
    '583ecea6-fb46-11e1-82cb-f4ce4684ea4c': { key: 'MIA', baseColor: "#98002E", secondaryColor: "#F9A01B" }, // Miami Heat
    '583ed157-fb46-11e1-82cb-f4ce4684ea4c': { key: 'ORL', baseColor: "#0077C0", secondaryColor: "#C4CED4" }, // Orlando Magic
    '583ec70e-fb46-11e1-82cb-f4ce4684ea4c': { key: 'NYK', baseColor: "#006BB6", secondaryColor: "#F58426" }, // New York Knicks
    '583ec87d-fb46-11e1-82cb-f4ce4684ea4c': { key: 'PHI', baseColor: "#006BB6", secondaryColor: "#ED174C" }, // Philadelphia 76ers
    '583ec9d6-fb46-11e1-82cb-f4ce4684ea4c': { key: 'BKN', baseColor: "#000000", secondaryColor: "#FFFFFF" }, // Brooklyn Nets
    '583eccfa-fb46-11e1-82cb-f4ce4684ea4c': { key: 'BOS', baseColor: "#007A33", secondaryColor: "#BA9653" }, // Boston Celtics
    '583ecda6-fb46-11e1-82cb-f4ce4684ea4c': { key: 'TOR', baseColor: "#CE1141", secondaryColor: "#000000" }, // Toronto Raptors
    '583ec5fd-fb46-11e1-82cb-f4ce4684ea4c': { key: 'CHI', baseColor: "#CE1141", secondaryColor: "#000000" }, // Chicago Bulls
    '583ec773-fb46-11e1-82cb-f4ce4684ea4c': { key: 'CLE', baseColor: "#860038", secondaryColor: "#FDBB30" }, // Cleveland Cavaliers
    '583ec7cd-fb46-11e1-82cb-f4ce4684ea4c': { key: 'IND', baseColor: "#002D62", secondaryColor: "#FDBB30" }, // Indiana Pacers
    '583ec928-fb46-11e1-82cb-f4ce4684ea4c': { key: 'DET', baseColor: "#C8102E", secondaryColor: "#006BB6" }, // Detroit Pistons
    '583ecefd-fb46-11e1-82cb-f4ce4684ea4c': { key: 'MIL', baseColor: "#00471B", secondaryColor: "#EEE1C6" }, // Milwaukee Bucks
    '583eca2f-fb46-11e1-82cb-f4ce4684ea4c': { key: 'MIN', baseColor: "#0C2340", secondaryColor: "#236192" }, // Minnesota Timberwolves
    '583ece50-fb46-11e1-82cb-f4ce4684ea4c': { key: 'UTA', baseColor: "#002B5C", secondaryColor: "#00471B" }, // Utah Jazz
    '583ecfff-fb46-11e1-82cb-f4ce4684ea4c': { key: 'OKC', baseColor: "#007AC1", secondaryColor: "#EF3B24" }, // Oklahoma City Thunder
    '583ed056-fb46-11e1-82cb-f4ce4684ea4c': { key: 'POR', baseColor: "#E03A3E", secondaryColor: "#000000" }, // Portland Trail Blazers
    '583ed102-fb46-11e1-82cb-f4ce4684ea4c': { key: 'DEN', baseColor: "#0E2240", secondaryColor: "#FEC524" }, // Denver Nuggets
    '583eca88-fb46-11e1-82cb-f4ce4684ea4c': { key: 'MEM', baseColor: "#5D76A9", secondaryColor: "#12173F" }, // Memphis Grizzlies
    '583ecb3a-fb46-11e1-82cb-f4ce4684ea4c': { key: 'HOU', baseColor: "#CE1141", secondaryColor: "#C4CED4" }, // Houston Rockets
    '583ecc9a-fb46-11e1-82cb-f4ce4684ea4c': { key: 'NOP', baseColor: "#0C2340", secondaryColor: "#C8102E" }, // New Orleans Pelicans
    '583ecd4f-fb46-11e1-82cb-f4ce4684ea4c': { key: 'SAS', baseColor: "#C4CED4", secondaryColor: "#000000" }, // San Antonio Spurs
    '583ecf50-fb46-11e1-82cb-f4ce4684ea4c': { key: 'DAL', baseColor: "#00538C", secondaryColor: "#002B5E" }, // Dallas Mavericks
    '583ec825-fb46-11e1-82cb-f4ce4684ea4c': { key: 'GSW', baseColor: "#1D428A", secondaryColor: "#FFC72C" }, // Golden State Warriors
    '583ecae2-fb46-11e1-82cb-f4ce4684ea4c': { key: 'LAL', baseColor: "#552583", secondaryColor: "#FDB927" }, // Los Angeles Lakers
    '583ecdfb-fb46-11e1-82cb-f4ce4684ea4c': { key: 'LAC', baseColor: "#C8102E", secondaryColor: "#1D428A" }, // Los Angeles Clippers
    '583ecfa8-fb46-11e1-82cb-f4ce4684ea4c': { key: 'PHX', baseColor: "#1D1160", secondaryColor: "#E56020" }, // Phoenix Suns
    '583ed0ac-fb46-11e1-82cb-f4ce4684ea4c': { key: 'SAC', baseColor: "#5A2D81", secondaryColor: "#63727A" }, // Sacramento Kings
};
export const NFLTeams = {
    '768c92aa-75ff-4a43-bcc0-f2798c2e1724': {key: 'BUF', baseColor: "#00338D", secondaryColor: "#C60C30"}, // Buffalo Bills
    '4809ecb0-abd3-451d-9c4a-92a90b83ca06': {key: 'MIA', baseColor: "#008E97", secondaryColor: "#F58220"}, // Miami Dolphins
    '5fee86ae-74ab-4bdd-8416-42a9dd9964f3': {key: 'NYJ', baseColor: "#125740", secondaryColor: "#FFFFFF"}, // New York Jets
    '97354895-8c77-4fd4-a860-32e62ea7382a': {key: 'NE', baseColor: "#002244", secondaryColor: "#C60C30"}, // New England Patriots
    'ad4ae08f-d808-42d5-a1e6-e9bc4e34d123': {key: 'CIN', baseColor: "#FB4F14", secondaryColor: "#000000"}, // Cincinnati Bengals
    'd5a2eb42-8065-4174-ab79-0a6fa820e35e': {key: 'CLE', baseColor: "#311D00", secondaryColor: "#FF3C00"}, // Cleveland Browns
    'ebd87119-b331-4469-9ea6-d51fe3ce2f1c': {key: 'BAL', baseColor: "#241773", secondaryColor: "#9E7C0C"}, // Baltimore Ravens
    'cb2f9f1f-ac67-424e-9e72-1475cb0ed398': {key: 'PIT', baseColor: "#FFB612", secondaryColor: "#101820"}, // Pittsburgh Steelers
    '82cf9565-6eb9-4f01-bdbd-5aa0d472fcd9': {key: 'IND', baseColor: "#002C5F", secondaryColor: "#A2AAAD"}, // Indianapolis Colts
    'f7ddd7fa-0bae-4f90-bc8e-669e4d6cf2de': {key: 'JAC', baseColor: "#006778", secondaryColor: "#D7A22A"}, // Jacksonville Jaguars
    '82d2d380-3834-4938-835f-aec541e5ece7': {key: 'HOU', baseColor: "#03202F", secondaryColor: "#A71930"}, // Houston Texans
    'd26a1ca5-722d-4274-8f97-c92e49c96315': {key: 'TEN', baseColor: "#4B92DB", secondaryColor: "#0C2340"}, // Tennessee Titans
    'ce92bd47-93d5-4fe9-ada4-0fc681e6caa0': {key: 'DEN', baseColor: "#FB4F14", secondaryColor: "#002244"}, // Denver Broncos
    '1f6dcffb-9823-43cd-9ff4-e7a8466749b5': {key: 'LAC', baseColor: "#0080C6", secondaryColor: "#FFC20E"}, // Los Angeles Chargers
    '6680d28d-d4d2-49f6-aace-5292d3ec02c2': {key: 'KC', baseColor: "#E31837", secondaryColor: "#FFB81C"}, // Kansas City Chiefs
    '7d4fcc64-9cb5-4d1b-8e75-8a906d1e1576': {key: 'LV', baseColor: "#000000", secondaryColor: "#A5ACAF"}, // Las Vegas Raiders
    'e627eec7-bbae-4fa4-8e73-8e1d6bc5c060': {key: 'DAL', baseColor: "#003594", secondaryColor: "#869397"}, // Dallas Cowboys
    '386bdbf9-9eea-4869-bb9a-274b0bc66e80': {key: 'PHI', baseColor: "#004C54", secondaryColor: "#A5ACAF"}, // Philadelphia Eagles
    '22052ff7-c065-42ee-bc8f-c4691c50e624': {key: 'WAS', baseColor: "#773141", secondaryColor: "#FFB612"}, // Washington Commanders
    '04aa1c9d-66da-489d-b16a-1dee3f2eec4d': {key: 'NYG', baseColor: "#0B2265", secondaryColor: "#A71930"}, // New York Giants
    '7b112545-38e6-483c-a55c-96cf6ee49cb8': {key: 'CHI', baseColor: "#C83803", secondaryColor: "#0B162A"}, // Chicago Bears
    'c5a59daa-53a7-4de0-851f-fb12be893e9e': {key: 'DET', baseColor: "#0076B6", secondaryColor: "#B0B7BC"}, // Detroit Lions
    'a20471b4-a8d9-40c7-95ad-90cc30e46932': {key: 'GB', baseColor: "#203731", secondaryColor: "#FFB612"}, // Green Bay Packers
    '33405046-04ee-4058-a950-d606f8c30852': {key: 'MIN', baseColor: "#4F2683", secondaryColor: "#FFC62F"}, // Minnesota Vikings
    '4254d319-1bc7-4f81-b4ab-b5e6f3402b69': {key: 'TB', baseColor: "#D50A0A", secondaryColor: "#FF7900"}, // Tampa Bay Buccaneers
    'e6aa13a4-0055-48a9-bc41-be28dc106929': {key: 'ATL', baseColor: "#A71930", secondaryColor: "#000000"}, // Atlanta Falcons
    'f14bf5cc-9a82-4a38-bc15-d39f75ed5314': {key: 'CAR', baseColor: "#0085CA", secondaryColor: "#101820"}, // Carolina Panthers
    '0d855753-ea21-4953-89f9-0e20aff9eb73': {key: 'NO', baseColor: "#D3BC8D", secondaryColor: "#101820"}, // New Orleans Saints
    'f0e724b0-4cbf-495a-be47-013907608da9': {key: 'SF', baseColor: "#AA0000", secondaryColor: "#B3995D"}, // San Francisco 49ers
    'de760528-1dc0-416a-a978-b510d20692ff': {key: 'ARI', baseColor: "#97233F", secondaryColor: "#000000"}, // Arizona Cardinals
    '2eff2a03-54d4-46ba-890e-2bc3925548f3': {key: 'LA', baseColor: "#003594", secondaryColor: "#FFA300"}, // Los Angeles Rams
    '3d08af9e-c767-4f88-a7dc-b920c6d2b4a8': {key: 'SEA', baseColor: "#002244", secondaryColor: "#69BE28"} // Seattle Seahawks
};
export const MLBTeams = {
    "1d678440-b4b1-4954-9b39-70afb3ebbcfa": {key: "TOR", baseColor: "#134A8E", secondaryColor: "#1D2D5C"}, // Toronto Blue Jays
    "bdc11650-6f74-49c4-875e-778aeb7632d9": {key: "TB", baseColor: "#092C5C", secondaryColor: "#8FBCE6"}, // Tampa Bay Rays
    "75729d34-bca7-4a0f-b3df-6f26c6ad3719": {key: "BAL", baseColor: "#DF4601", secondaryColor: "#000000"}, // Baltimore Orioles
    "93941372-eb4c-4c40-aced-fe3267174393": {key: "BOS", baseColor: "#BD3039", secondaryColor: "#0C2340"}, // Boston Red Sox
    "a09ec676-f887-43dc-bbb3-cf4bbaee9a18": {key: "NYY", baseColor: "#0C2340", secondaryColor: "#003087"}, // New York Yankees
    "833a51a9-0d84-410f-bd77-da08c3e5e26e": {key: "KC", baseColor: "#004687", secondaryColor: "#BD9B60"}, // Kansas City Royals
    "80715d0d-0d2a-450f-a970-1b9a3b18c7e7": {key: "CLE", baseColor: "#00385D", secondaryColor: "#E50022"}, // Cleveland Guardians
    "47f490cd-2f58-4ef7-9dfd-2ad6ba6c1ae8": {key: "CWS", baseColor: "#27251F", secondaryColor: "#C4CED4"}, // Chicago White Sox
    "575c19b7-4052-41c2-9f0a-1c5813d02f99": {key: "DET", baseColor: "#0C2340", secondaryColor: "#FA4616"}, // Detroit Tigers
    "aa34e0ed-f342-4ec6-b774-c79b47b60e2d": {key: "MIN", baseColor: "#002B5C", secondaryColor: "#D31145"}, // Minnesota Twins
    "43a39081-52b4-4f93-ad29-da7f329ea960": {key: "SEA", baseColor: "#0C2C56", secondaryColor: "#005C5C"}, // Seattle Mariners
    "4f735188-37c8-473d-ae32-1f7e34ccf892": {key: "LAA", baseColor: "#003263", secondaryColor: "#BA0021"}, // Los Angeles Angels
    "27a59d3b-ff7c-48ea-b016-4798f560f5e1": {key: "OAK", baseColor: "#003831", secondaryColor: "#EFB21E"}, // Oakland Athletics
    "d99f919b-1534-4516-8e8a-9cd106c6d8cd": {key: "TEX", baseColor: "#003278", secondaryColor: "#C0111F"}, // Texas Rangers
    "eb21dadd-8f10-4095-8bf3-dfb3b779f107": {key: "HOU", baseColor: "#002D62", secondaryColor: "#EB6E1F"}, // Houston Astros
    "c874a065-c115-4e7d-b0f0-235584fb0e6f": {key: "CIN", baseColor: "#C6011F", secondaryColor: "#000000"}, // Cincinnati Reds
    "481dfe7e-5dab-46ab-a49f-9dcc2b6e2cfd": {key: "PIT", baseColor: "#27251F", secondaryColor: "#FDB827"}, // Pittsburgh Pirates
    "55714da8-fcaf-4574-8443-59bfb511a524": {key: "CHC", baseColor: "#0E3386", secondaryColor: "#CC3433"}, // Chicago Cubs
    "44671792-dc02-4fdd-a5ad-f5f17edaa9d7": {key: "STL", baseColor: "#0C2C56", secondaryColor: "#005C5C"}, // St. Louis Cardinals
    "dcfd5266-00ce-442c-bc09-264cd20cf455": {key: "MIL", baseColor: "#12284B", secondaryColor: "#FFC52F"}, // Milwaukee Brewers
    "ef64da7f-cfaf-4300-87b0-9313386b977c": {key: "LAD", baseColor: "#005A9C", secondaryColor: "#EF3E42"}, // Los Angeles Dodgers
    "25507be1-6a68-4267-bd82-e097d94b359b": {key: "ARI", baseColor: "#A71930", secondaryColor: "#E3D4AD"}, // Arizona Diamondbacks
    "a7723160-10b7-4277-a309-d8dd95a8ae65": {key: "SF", baseColor: "#FD5A1E", secondaryColor: "#27251F"}, // San Francisco Giants
    "29dd9a87-5bcc-4774-80c3-7f50d985068b": {key: "COL", baseColor: "#333366", secondaryColor: "#C4CED4"}, // Colorado Rockies
    "d52d5339-cbdd-43f3-9dfa-a42fd588b9a3": {key: "SD", baseColor: "#eeaf17", secondaryColor: "#2F241D"}, // San Diego Padres
    "2142e1ba-3b40-445c-b8bb-f1f8b1054220": {key: "PHI", baseColor: "#E81828", secondaryColor: "#002D72"}, // Philadelphia Phillies
    "f246a5e5-afdb-479c-9aaa-c68beeda7af6": {key: "NYM", baseColor: "#002D72", secondaryColor: "#FF5910"}, // New York Mets
    "03556285-bdbb-4576-a06d-42f71f46ddc5": {key: "MIA", baseColor: "#00A3E0", secondaryColor: "#EF3340"}, // Miami Marlins
    "12079497-e414-450a-8bf2-29f91de646bf": {key: "ATL", baseColor: "#CE1141", secondaryColor: "#13274F"}, // Atlanta Braves
    "d89bed32-3aee-4407-99e3-4103641b999a": {key: "WSH", baseColor: "#AB0003", secondaryColor: "#14225A"}, // Washington Nationals
};
export const SoccerTeams = {
    // Ligue 1 Teams
    '1641': {key: 'OM', baseColor: "#2FAEE0", secondaryColor: "#BEA064"}, // Olympique de Marseille
    '1678': {key: 'STE', baseColor: "#008D3F", secondaryColor: "#FFFFFF"}, // AS Saint-Étienne
    '1645': {key: 'BOR', baseColor: "#001B50", secondaryColor: "#FFFFFF"}, // Girondins de Bordeaux
    '1647': {key: 'FCN', baseColor: "#FCD405", secondaryColor: "#1B8F3A"}, // FC Nantes
    '1686': {key: 'DIJ', baseColor: "#e50001", secondaryColor: "#FFFFFF"}, // Dijon FCO
    '1684': {key: 'ANG', baseColor: "#000000", secondaryColor: "#FFFFFF"}, // Angers SCO
    '1643': {key: 'LIL', baseColor: "#E01E13", secondaryColor: "#24216A"}, // Lille OSC
    '1658': {key: 'REN', baseColor: "#E13327", secondaryColor: "#000000"}, // Stade Rennais FC
    '1653': {key: 'ASM', baseColor: "#E51B22", secondaryColor: "#CB9F18"}, // AS Monaco FC
    '1682': {key: 'SDR', baseColor: "#EE2223", secondaryColor: "#FFFFFF"}, // Stade de Reims
    '1663': {key: 'NIM', baseColor: "#EE2223", secondaryColor: "#000000"}, // Nîmes Olympique
    '1715': {key: 'STB', baseColor: "#ED1C24", secondaryColor: "#FFFFFF"}, // Stade Brestois 29
    '1656': {key: 'FCL', baseColor: "#F58113", secondaryColor: "#000000"}, // FC Lorient
    '1659': {key: 'RCS', baseColor: "#009FE3", secondaryColor: "#DC2F34"}, // RC Strasbourg Alsace
    '1642': {key: 'MHS', baseColor: "#344575", secondaryColor: "#D87043"}, // Montpellier HSC
    '1649': {key: 'OL', baseColor: "#F58113", secondaryColor: "#000000"}, // Olympique Lyonnais
    '1661': {key: 'NIC', baseColor: "#000000", secondaryColor: "#ED1C24"}, // OGC Nice
    '1648': {key: 'RCL', baseColor: "#EC1C24", secondaryColor: "#FFF200"}, // RC Lens
    '1644': {key: 'PSG', baseColor: "#004170", secondaryColor: "#FFFFFF"}, // Paris Saint-Germain
    '1651': {key: 'FCM', baseColor: "#6E0F12", secondaryColor: "#FFFFFF"},  // FC Metz
    '1646': {key: 'AUX', baseColor: "#1D3C4A", secondaryColor: "#FFFFFF"}, // Auxerre
    '1652': {key: 'EST', baseColor: "#0000FF", secondaryColor: "#FFFFFF"}, // Estac Troyes
    '1654': {key: 'EAG', baseColor: "#CC0033", secondaryColor: "#000000"}, // En Avant de Guingamp
    '1655': {key: 'SCB', baseColor: "#0050B3", secondaryColor: "#FFFFFF"}, // Sporting Club Bastia
    '1657': {key: 'FCSM', baseColor: "#FFD700", secondaryColor: "#000080"}, // FC Sochaux-Montbéliard
    '1660': {key: 'ACA', baseColor: "#FFFFFF", secondaryColor: "#FF0000"}, // AC Ajaccio
    '1662': {key: 'HAC', baseColor: "#4B92DB", secondaryColor: "#1F2937"}, // Le Havre AC
    '1665': {key: 'NIO', baseColor: "#000000", secondaryColor: "#FFFFFF"}, // Chamois Niortais FC
    '1667': {key: 'SMC', baseColor: "#0033A0", secondaryColor: "#CC0033"}, // Stade Malherbe Caen
    '1671': {key: 'GRE', baseColor: "#FFFFFF", secondaryColor: "#0070BB"}, // Grenoble Foot 38
    '1675': {key: 'ASN', baseColor: "#008000", secondaryColor: "#FFFFFF"}, // AS Nancy Lorraine
    '1676': {key: 'AMI', baseColor: "#FFFFFF", secondaryColor: "#000000"}, // Amiens SC
    '1680': {key: 'CFA', baseColor: "#FFD700", secondaryColor: "#000080"}, // Clermont Foot
    '1681': {key: 'TFC', baseColor: "#4B0082", secondaryColor: "#FFFFFF"}, // Toulouse FC
    '1685': {key: 'PAU', baseColor: "#FFD700", secondaryColor: "#0000FF"}, // Pau FC
    '233162': {key: 'QRO', baseColor: "#0000FF", secondaryColor: "#FFFFFF"}, // Quevilly-Rouen Métropole
    '5061': {key: 'VAL', baseColor: "#D3D3D3", secondaryColor: "#000000"}, // Valenciennes FC
    '6070': {key: 'PAR', baseColor: "#0000FF", secondaryColor: "#FF0000"}, // Paris FC
    '6918': {key: 'DUN', baseColor: "#FFD700", secondaryColor: "#000000"}, // USL Dunkerque
    '6925': {key: 'ROD', baseColor: "#FF0000", secondaryColor: "#FFFF00"},  // Rodez AF
    // MX Teams
    '1944': {key: 'NCX', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Necaxa
    '1950': {key: 'ASL', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Atlético San Luis
    '1946': {key: 'MAZ', baseColor: "#512888", secondaryColor: "#FFFFFF"}, // Mazatlán FC
    '36534': {key: 'LEO', baseColor: "#0B8645", secondaryColor: "#FFFFFF"}, // León
    '1939': {key: 'AME', baseColor: "#FFD700", secondaryColor: "#000080"}, // Club América
    '1951': {key: 'QUE', baseColor: "#000000", secondaryColor: "#FFFFFF"}, // Querétaro
    '1949': {key: 'ATL', baseColor: "#ED1C24", secondaryColor: "#0000FF"}, // Atlas
    '1931': {key: 'TOL', baseColor: "#D71920", secondaryColor: "#FFFFFF"}, // Toluca
    '1932': {key: 'MON', baseColor: "#002B5C", secondaryColor: "#FFFFFF"}, // Monterrey
    '1938': {key: 'GDC', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Guadalajara (Chivas)
    '1933': {key: 'PUM', baseColor: "#FFD700", secondaryColor: "#000080"}, // Pumas UNAM
    '215048': {key: 'JUA', baseColor: "#1B5E20", secondaryColor: "#FFFFFF"}, // Juárez
    '1948': {key: 'SLA', baseColor: "#008000", secondaryColor: "#FFFFFF"}, // Santos Laguna
    '1940': {key: 'TIG', baseColor: "#FFD700", secondaryColor: "#0000FF"}, // Tigres UANL
    '36525': {key: 'TIJ', baseColor: "#FF0000", secondaryColor: "#000000"}, // Tijuana
    '1947': {key: 'CAZ', baseColor: "#0000FF", secondaryColor: "#FFFFFF"}, // Cruz Azul
    '1936': {key: 'PAC', baseColor: "#008B8B", secondaryColor: "#FFFFFF"}, // Pachuca
    '1941': {key: 'PUE', baseColor: "#0000FF", secondaryColor: "#FFFFFF"}, // Puebla
    // MLS Teams
    '668063': { key: 'NSC', baseColor: "#F0E68C", secondaryColor: "#4B0082" },  // Nashville SC
    '167510': { key: 'NYC', baseColor: "#6CADDF", secondaryColor: "#041E42" },  // New York City FC
    '305920': { key: 'ATL', baseColor: "#A50031", secondaryColor: "#000000" },  // Atlanta United FC
    '21825': { key: 'SJ', baseColor: "#0055A4", secondaryColor: "#000000" },  // San Jose Earthquakes
    '863473': { key: 'CHA', baseColor: "#00B2A9", secondaryColor: "#26282A" },  // Charlotte FC
    '2511': { key: 'NE', baseColor: "#0A2240", secondaryColor: "#ED1C24" },  // New England Revolution
    '245305': { key: 'CIN', baseColor: "#003087", secondaryColor: "#FF5000" },  // FC Cincinnati
    '2508': { key: 'HOU', baseColor: "#FF6C0E", secondaryColor: "#101820" },  // Houston Dynamo FC
    '2502': { key: 'DC', baseColor: "#E31837", secondaryColor: "#000000" },  // D.C. United
    '7080': { key: 'TOR', baseColor: "#E31837", secondaryColor: "#393B3D" },  // Toronto FC
    '659691': { key: 'MIA', baseColor: "#F7B5CD", secondaryColor: "#231F20" },  // Inter Miami CF
    '22006': { key: 'MON', baseColor: "#004C90", secondaryColor: "#000000" },  // CF Montréal
    '52237': { key: 'ORL', baseColor: "#633492", secondaryColor: "#F4B000" },  // Orlando City SC
    '2506': { key: 'NY', baseColor: "#D6001C", secondaryColor: "#002F65" },  // New York Red Bulls
    '39833': { key: 'PHI', baseColor: "#001B2D", secondaryColor: "#B1862C" },  // Philadelphia Union
    '2504': { key: 'CLB', baseColor: "#FFD100", secondaryColor: "#231F20" },  // Columbus Crew SC
    '772256': { key: 'ATX', baseColor: "#000000", secondaryColor: "#FFFFFF" },  // Austin FC
    '874725': { key: 'SAI', baseColor: "#00B140", secondaryColor: "#004B87" },  // San Antonio FC
    '2512': { key: 'DAL', baseColor: "#BD2031", secondaryColor: "#002469" },  // FC Dallas
    '41618': { key: 'MIN', baseColor: "#8D8D8C", secondaryColor: "#231F20" },  // Minnesota United FC
    '2513': { key: 'LAG', baseColor: "#00245D", secondaryColor: "#FFD200" },  // LA Galaxy
    '402227': { key: 'LAN', baseColor: "#FFD200", secondaryColor: "#00245D" },  // Los Angeles FC
    '22010': { key: 'VAN', baseColor: "#041C2C", secondaryColor: "#94C7ED" },  // Vancouver Whitecaps FC
    '5133': { key: 'RSL', baseColor: "#A51C30", secondaryColor: "#F2C841" },  // Real Salt Lake
    '22009': { key: 'SEA', baseColor: "#005595", secondaryColor: "#84BD00" },  // Seattle Sounders FC
    '2510': { key: 'COL', baseColor: "#960A2C", secondaryColor: "#C9A058" },  // Colorado Rapids
    '22007': { key: 'POR', baseColor: "#004812", secondaryColor: "#F7E842" },  // Portland Timbers
    '2509': { key: 'SKC', baseColor: "#1A4784", secondaryColor: "#91C5DF" },  // Sporting Kansas City
    '2505': { key: 'CHI', baseColor: "#15151E", secondaryColor: "#8A8D8F" },  // Chicago Fire FC
    // Premier League Teams
    '6': {key: 'BUR', baseColor: "#6C1D45", secondaryColor: "#99D6EA"}, // Burnley
    '17': {key: 'MCI', baseColor: "#6CABDD", secondaryColor: "#1C2C5B"}, // Manchester City
    '42': {key: 'ARS', baseColor: "#EF0107", secondaryColor: "#FFFFFF"}, // Arsenal
    '14': {key: 'NFO', baseColor: "#E53233", secondaryColor: "#FFFFFF"}, // Nottingham Forest
    '60': {key: 'BOU', baseColor: "#DA291C", secondaryColor: "#000000"}, // Bournemouth
    '37': {key: 'WHU', baseColor: "#7A263A", secondaryColor: "#1BB1E7"}, // West Ham United
    '30': {key: 'BRI', baseColor: "#0057B8", secondaryColor: "#FFFFFF"}, // Brighton & Hove Albion
    '72': {key: 'LUT', baseColor: "#FF7300", secondaryColor: "#000000"}, // Luton Town
    '48': {key: 'EVE', baseColor: "#003399", secondaryColor: "#FFFFFF"}, // Everton
    '43': {key: 'FUL', baseColor: "#FFFFFF", secondaryColor: "#000000"}, // Fulham
    '15': {key: 'SHU', baseColor: "#FF0000", secondaryColor: "#000000"}, // Sheffield United
    '7': {key: 'CRY', baseColor: "#1B458F", secondaryColor: "#A7A5A6"}, // Crystal Palace
    '39': {key: 'NEW', baseColor: "#241F20", secondaryColor: "#FFFFFF"}, // Newcastle United
    '40': {key: 'AVL', baseColor: "#95BFE5", secondaryColor: "#A3C3D9"}, // Aston Villa
    '50': {key: 'BRE', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Brentford
    '33': {key: 'TOT', baseColor: "#132257", secondaryColor: "#FFFFFF"}, // Tottenham Hotspur
    '38': {key: 'CHE', baseColor: "#034694", secondaryColor: "#FFFFFF"}, // Chelsea
    '44': {key: 'LIV', baseColor: "#C8102E", secondaryColor: "#00B2A9"}, // Liverpool
    '35': {key: 'MUN', baseColor: "#DA291C", secondaryColor: "#FFD100"}, // Manchester United
    '3': {key: 'WOL', baseColor: "#FDB913", secondaryColor: "#231F20"}, // Wolverhampton Wanderers
    // International Teams
    '4477': {key: 'ROU', baseColor: "#F0C012", secondaryColor: "#D2251E"}, // Romania
    '4700': {key: 'TUR', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Turkey
    '4707': {key: 'ITA', baseColor: "#103cd6", secondaryColor: "#FFFFFF"}, // Italy
    '4702': {key: 'WAL', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Wales
    '4690': {key: 'ALB', baseColor: "#A80426", secondaryColor: "#FFFFFF"}, // Albania
    '4699': {key: 'SUI', baseColor: "#FF0000", secondaryColor: "#740C14"}, // Switzerland
    '4476': {key: 'DEN', baseColor: "#CD181E", secondaryColor: "#FFFFFF"}, // Denmark
    '4712': {key: 'FIN', baseColor: "#87cefa", secondaryColor: "#000088"}, // Finland
    '4717': {key: 'BEL', baseColor: "#E30613", secondaryColor: "#FFD700"}, // Belgium
    '4694': {key: 'RUS', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Russia
    '4713': {key: 'ENG', baseColor: "#000040", secondaryColor: "#FFFFFF"}, // England
    '4715': {key: 'CRO', baseColor: "#ED1C24", secondaryColor: "#DFB770"}, // Croatia
    '4718': {key: 'AUT', baseColor: "#000000", secondaryColor: "#FF0000"}, // Austria
    '4777': {key: 'MKD', baseColor: "#D20000", secondaryColor: "#FFCC00"}, // North Macedonia
    '4705': {key: 'NED', baseColor: "#FF4B00", secondaryColor: "#21468B"}, // Netherlands
    '4701': {key: 'UKR', baseColor: "#FFD700", secondaryColor: "#0057B7"}, // Ukraine
    '4695': {key: 'SCO', baseColor: "#003876", secondaryColor: "#FFFFFF"}, // Scotland
    '4714': {key: 'CZE', baseColor: "#D7141A", secondaryColor: "#FFFFFF"}, // Czech Republic
    '4703': {key: 'POL', baseColor: "#DC143C", secondaryColor: "#FFFFFF"}, // Poland
    '4763': {key: 'GEO', baseColor: "#FF0000", secondaryColor: "#FFFFFF"}, // Georgia
    '4697': {key: 'SVK', baseColor: "#004B87", secondaryColor: "#FFFFFF"}, // Slovakia
    '4698': {key: 'ESP', baseColor: "#AA151B", secondaryColor: "#F1BF00"}, // Spain
    '4688': {key: 'SWE', baseColor: "#FFCD00", secondaryColor: "#004B87"}, // Sweden
    '4709': {key: 'HUN', baseColor: "#C60C30", secondaryColor: "#FFFFFF"}, // Hungary
    '4704': {key: 'POR', baseColor: "#006600", secondaryColor: "#FF0000"}, // Portugal
    '4481': {key: 'FRA', baseColor: "#0055A4", secondaryColor: "#EF4135"}, // France
    '4711': {key: 'GER', baseColor: "#FFFFFF", secondaryColor: "#000000"}, // Germany
    '6355': {key: 'SRB', baseColor: "#C6363C", secondaryColor: "#FFFFFF"}, // Serbia
    // Unknown Teams
    '677457': {key: '2A', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677459': {key: '2B', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677447': {key: '1A', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677461': {key: '2C', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677449': {key: '1C', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677353': {key: '3EDF', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677445': {key: '1B', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677355': {key: 'ADEF', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677463': {key: '2D', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677465': {key: '2E', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677455': {key: '1F', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677357': {key: '3ABC', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677451': {key: '1D', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677467': {key: '2F', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677453': {key: '1E', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677359': {key: 'ABCD', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677475': {key: 'W41', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677477': {key: 'W42', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677471': {key: 'W39', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '684169': {key: 'W37', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677473': {key: 'W40', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677469': {key: 'W38', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677479': {key: 'W43', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677481': {key: 'W44', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677485': {key: 'W46', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677483': {key: 'W45', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677489': {key: 'W48', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677487': {key: 'W47', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677497': {key: 'W49', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
    '677495': {key: 'W50', baseColor: "#FFFFFF", secondaryColor: "#FFFFFF"},
};
export const soccer_teamName = {
    "TUR": "Turkey",
    "ITA": "Italy",
    "WAL": "Wales",
    "SUI": "Switzerland",
    "DEN": "Denmark",
    "FIN": "Finland",
    "BEL": "Belgium",
    "RUS": "Russia",
    "ENG": "England",
    "CRO": "Croatia",
    "AUT": "Austria",
    "MKD": "North Macedonia",
    "NED": "Netherlands",
    "UKR": "Ukraine",
    "SCO": "Scotland",
    "CZE": "Czech Republic",
    "POL": "Poland",
    "SVK": "Slovakia",
    "ESP": "Spain",
    "SWE": "Sweden",
    "HUN": "Hungary",
    "POR": "Portugal",
    "FRA": "France",
    "GER": "Germany",
};

//Markets
export const StatsKeys = {
    //Hockey
    1:[
        {label:"Shots on Goal (Skaters)", value:"SOG"}, //SOG
        {label:"Saves (Goalies)", value:"Saves"},
    ],
        //BasketBall
        2:[
        {label:"Points", value:"Points"}
    ],
        //Soccer
        3 :[
        {label: "Completed Passes (Players)", value:"TCP"}, //TCP
        {label: "Saves (Goalies)", value:"Saves"},
        {label: "Anytime Goals", value:"Goals"},
        {label: "Assists", value:"Assists"},
        {label: "TacklesWon", value:"TacklesWon"},
        {label: "FoulsCommitted", value:"FoulsCommitted"},
    ],
        //Football
        4 :[
        {label: "Passing Yards (Quarterbacks)", value:"Passing.Yards"},
        {label: "Receiving Yards (Wide Receiver)", value:"Receiving.Yards"},
    ],
        //BaseBall
        9:[
        {label: "HRR: Hit + Runs + RBIs (Batters)", value:"Hitting.HRR"},
        {label: "Strikeouts (Pitchers)", value:"Pitching.Strikeouts"}, //Pitching.Outs.ktotal
        {label: "Earned Runs (Pitchers)", value:"Pitching.EarnedRuns"},
        {label: "Hits (Batters)", value:"Hitting.Hits"},
        {label: "Runs (Batters)", value:"Hitting.Runs"},
        {label: "RBIs (Batters)", value:"Hitting.RBIs"},
        {label: "Strikeouts (Batters)", value:"Hitting.Strikeouts"},
        {label: "Bases (Batters)", value:"Hitting.Bases"},
    ],
        //Golf
        12:[
        {label: "Birdies", value:"TBM"}, //Birdies
        //Total Base
    ]
}


export const getCurrentSeasonYearsBySportAndSeason = (sportId, seasonId) => {
    if (sportId === 1) {
        return [2024,2025];
    }
    if (sportId === 2) {
        return [2024,2025];
    }
    if (sportId === 3) {
        //todo: this will also depends seasonId
        return [2024,2025];
    }
    if (sportId === 4) {
        return [2024,2025];
    }
    if (sportId === 9) {
        return [2024,2025];
    }

    return [2024,2025];
}



